import _debug from "./services/debug"
import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';
import { Accordion, Carousel, Modal } from 'flowbite';
import {node} from "../../../../../wordpress/wp-includes/js/clipboard";

const Controller = function () {
    this.cssClass = "fn";
};

/**
 *
 * @param manager
 */
Controller.prototype.init = function (manager) {
    this.manager = manager;
    _debug.log("initializing ajax");
    this.getNodes();
};

Controller.prototype.getNodes = function () {
    const _self = this, nodes = document.querySelectorAll("." + this.cssClass);

    _debug.log("initializing functions");

    Array.from(nodes).forEach(node => {
        if(node.hasAttribute("data-command")) {
            const methods = node.getAttribute("data-command").split(" ");

            methods.forEach(method => {
                if (typeof(_self[method]) === "function") {
                    _self[method](node);
                }
            })
        }
        else {
            _debug.warn("function on " + node.className + " not found, called by ", node);
        }

        node.classList.remove(_self.cssClass);
    });
};

// ***** Carousel ****** //

/**
 *
 * @param node
 */
Controller.prototype.carousel = function(node) {

    const slides = node.querySelectorAll("[data-carousel-item]"), items = [],
        interval = node.getAttribute("data-interval") || 100000,
        bullets = node.querySelectorAll("[data-carousel-bullet]"),
        indicators = [];

    slides.forEach((slide,i) => {
        items.push({
            position: i,
            el: slide
        });
    });

    bullets.forEach((bullet,i) => {
        indicators.push({
            position: i,
            el: bullet
        });
    });

    const options = {
        defaultPosition: 0,
        interval: interval,
        indicators: {
            items: indicators
        }
    }

    const carousel = new Carousel(node, items, options);

    carousel.cycle();

    const prevButton = node.querySelector('[data-carousel-prev]');
    const nextButton = node.querySelector('[data-carousel-next]');

    prevButton.addEventListener("click", () => {
        carousel.prev();
    });

    nextButton.addEventListener("click", () => {
        carousel.next();
    });

};

/**
 *
 * @param node
 */
Controller.prototype.swiper = function(node) {

    const slidesPerView = node.getAttribute("data-slides-per-view") || 2;

    const swiper = new Swiper(node, {
        modules: [Navigation, Pagination],
        spaceBetween: 20,
        slidesPerView: slidesPerView,
        sliderPerGroup: 1,
        direction: "horizontal",
        loop: true,
        // cssMode: true,
        // followFinger: false,
        resistance: false,
        longSwipes: false,
        autoHeight: true,
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            bulletActiveClass: "active",
            clickable: true
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                // pagination: false
            },
            768: {
                slidesPerView: slidesPerView >= 3 ? 3 : slidesPerView,
            },
            1000: {
                slidesPerView: slidesPerView >= 4 ? 4 : slidesPerView,
            },
        },
    });

};

// ***** Ajax ****** //

Controller.prototype.ajax = function(node) {

    const _self = this, trigger = document.querySelectorAll(node.getAttribute("data-trigger"));

    Array.from(trigger).forEach(link => {
        link.addEventListener("click", function(event) {
            const scrolling = node.getAttribute("data-scrolling") || false,
                url = this.getAttribute("href"),
                title = this.getAttribute("data-title") || null,
                state = {
                    item: this.getAttribute("data-item-id") || null,
                    area: this.getAttribute("data-item-area") || null,
                    origin: this.getAttribute("data-url") || document.querySelector("link[rel='canonical']").href,
                    type: "url"
                };

            Array.from(trigger).forEach(link => {
                link.parentElement.classList.remove("active");
            });
            this.parentElement.classList.add("active");

            if(location.href !== url) {
                window.history.pushState(state, title, url);
                if(title) {
                    document.title = title + " - " + document.head.querySelector('meta[property="og:title"]').content;
                }
                _self.loadUrl(url,node);
            }
            else {
                _self.scrollTo(scrolling,node);
            }

            event.preventDefault();
        });
    });

};

Controller.prototype.loadUrl = function(url,node,area = null, id = null) {

    const _self = this,
        scrolling = node.getAttribute("data-scrolling") || false,
        wrapper = node.getAttribute("data-wrapper") || false,
        loader = node.getAttribute("data-loader");

    node.innerHTML = '<div class="container mx-auto text-center">' +
        '<img src="' + loader + '" class="loader block mx-auto" alt="" />' +
        '</div>'

    node.classList.remove("hidden");

    if(area !== null) {
        const toggle = document.querySelector(".toggle.area-" + area);

        if(toggle && toggle.getAttribute("aria-expanded") === "false") {
            toggle.click();
        }
    }

    if(id !== null) {
        const link = document.querySelector('.ajax[data-item-id="' + id + '"]').parentElement;

        if(link) {
            link.classList.add("active");
        }
    }

    const xhr = new XMLHttpRequest();
    xhr.open("GET", url + "?xhr");
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.onload = function() {
        if (xhr.status === 200) {
            node.innerHTML = (wrapper ? '<div class="container mx-auto">' : '') +
                xhr.responseText +
                (wrapper ? '</div>' : '');

            _self.getNodes();
        }
        else {
            node.innerHTML = 'Request failed. Returned status of ' + xhr.status;

            node.innerHTML = (wrapper ? '<div class="container mx-auto">' : '') +
                'Request failed. Returned status of ' + xhr.status +
                (wrapper ? '</div>' : '')
        }
    };
    xhr.send();

    this.scrollTo(scrolling,node);

}

Controller.prototype.scrollTo = function(scrolling,container) {
    if(scrolling) {
        setTimeout(function() {
            window.scrollTo({
                top: container.offsetTop-50,
                left: 0,
                behavior: "smooth"
            });
        }, 100);

    }
};

// ***** Calendar ****** //

/**
 * @param node
 */
Controller.prototype.calendarPaging = function(node) {

    const _self = this,
        target = document.querySelector(node.getAttribute("data-target")),
        btns = node.querySelectorAll(".btn"),
        url = "/wp-admin/admin-ajax.php";

    target.style.height = target.offsetHeight + "px";

    Array.from(btns).forEach(btn => {
        btn.addEventListener("click",function(event){
            target.innerHTML = '<div role="status" class="h-full flex items-center">\n' +
                '    <svg aria-hidden="true" class="alignw-10 h-10 mx-auto text-gray-200 animate-spin dark:text-gray-600 fill-brand-b" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>\n' +
                '        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>\n' +
                '    </svg>\n' +
                '    <span class="sr-only">Lädt...</span>\n' +
                '</div>';

            const xhr = new XMLHttpRequest(),
                data = {
                    year: node.getAttribute("data-year"),
                    month: node.getAttribute("data-month"),
                    direction: this.getAttribute("data-direction") === "prev" ? "prev" : "next"
                };
            xhr.open('POST', url + "?action=calendar");
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

            xhr.onload = function() {
                if (xhr.status === 200) {
                    target.innerHTML = xhr.responseText;
                    _self.getNodes();
                    target.style.removeProperty("height");
                    target.style.height = target.offsetHeight + "px";
                }
                else if (xhr.status !== 200) {
                    target.innerHTML = 'Request failed.  Returned status of ' + xhr.status;
                }
            };
            xhr.send(new URLSearchParams(data).toString());

            event.preventDefault();
        });
    });

};

// ***** Download ****** //

/**
 * @param node
 */
Controller.prototype.download = async function (node) {

    const _self = this,
        trigger = node.querySelectorAll(node.getAttribute("data-trigger")),
        urlParams = new URLSearchParams(window.location.search);

    let wrapper = document.createElement("div"), wrapperId = node.getAttribute("data-wrapper-id");

    wrapper.setAttribute("data-download-list", wrapperId);
    wrapper.setAttribute("data-loader", node.getAttribute("data-loader"));
    wrapper.classList.add("mt-6", "section", "section-download", "section-collapse-top", "section-collapse-bottom", "hidden");

    node.parentNode.insertBefore(wrapper, node.nextSibling);

    await Array.from(trigger).forEach(a => {
        const href = a.getAttribute("href"),
            title = a.getAttribute("data-title") || null,
            state = {
                item: a.getAttribute("data-item-id") || null,
                area: wrapperId || null,
                origin: document.querySelector("link[rel='canonical']").href,
                type: "download"
            };

        a.addEventListener("click", function (event) {
            Array.from(trigger).forEach(link => {
                link.parentElement.classList.remove("active");
            });

            if (location.href !== href) {
                window.history.pushState(state, title, href);
                if (title) {
                    document.title = 'Downloads: ' + title + " - " + document.head.querySelector('meta[property="og:title"]').content;
                }
            } /*else {
                _self.scrollTo(1, wrapper);
            }*/

            _self.scrollTo(1, wrapper);
            _self.getDownloadList(wrapper, this);
            event.preventDefault();
        })
    });

    if (urlParams.get("tag")) {
        const item = node.querySelector("[data-tag='" + urlParams.get("tag") + "']");

        if (item) {
            const area = item.getAttribute("data-item-area");
            const btn = document.querySelector("[data-accordion-area='" + area + "'] > button");
            if (btn.getAttribute("aria-expanded") !== "true") {
                btn.click();
            }
            item.click();
        }
    }

};

/**
 *
 * @param wrapper
 * @param node
 */
Controller.prototype.getDownloadList = function(wrapper,node) {

    const _self = this, xhr = new XMLHttpRequest(),
        data = {
            post: node.getAttribute("data-post"),
            term: node.getAttribute("data-item-id"),
            tag: node.getAttribute("data-tag"),
            archive: node.getAttribute("data-archive") || ""
        };

    wrapper.innerHTML = '<img src="' + wrapper.getAttribute("data-loader") + '" class="loader block mx-auto" alt="" />';
    wrapper.classList.remove("hidden");

    node.parentElement.classList.add("active");

    xhr.open('POST', "/wp-admin/admin-ajax.php?action=download");
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onload = function() {
        if (xhr.status === 200) {
            wrapper.innerHTML = xhr.responseText;
            _self.getNodes();
        }
        else if (xhr.status !== 200) {
            wrapper.innerHTML = 'Request failed.  Returned status of ' + xhr.status;
        }
    };

    xhr.send(new URLSearchParams(data).toString());

};

// ***** Gallery ****** //

/**
 * @param node
 */
Controller.prototype.gallery = function(node) {

    const _self = this, modalFrame = document.createElement("div"), gallery = node.querySelectorAll("[data-gallery-img]");

    modalFrame.id = node.getAttribute("data-modal");
    modalFrame.setAttribute("aria-hidden","true");
    modalFrame.classList.add("fixed","top-0","left-0","right-0","z-50","hidden","w-full","p-4","overflow-x-hidden","overflow-y-auto","md:inset-0","h-modal","md:h-full");
    modalFrame.tabindex = "-1";
    modalFrame.innerHTML = '<div class="relative h-full max-w-5xl md:h-auto">\n' +
        '            <!-- Modal content -->\n' +
        '            <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">\n' +
        '                <!-- Modal header -->\n' +
        '                <div class="flex items-start justify-between p-4 border-b rounded-t dark:border-gray-600">\n' +
        '                    <div class="!m-0 text-xl font-semibold text-gray-900 dark:text-white" data-modal-title>Bild 1 von ' + Object.keys(gallery).length + '</div>\n' +
        '                    <button aria-pressed="false" aria-label="Gallerie schließen" data-modal-close type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">\n' +
        '                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>\n' +
        '                    </button>\n' +
        '                </div>\n' +
        '                <!-- Modal body -->\n' +
        '                <div data-modal-content>\n' +
        '                    <img src="<?php echo get_template_directory_uri(); ?>/img/loader.svg" alt="" class="loader" />\n' +
        '                </div>\n' +
        '                <!-- Modal footer -->\n' +
        '                <div class="flex items-center justify-between p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600">\n' +
        '                    <button data-modal-prev type="button" class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">Vorheriges Bild</button>\n' +
        '                    <button data-modal-next type="button" class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">Nächstes Bild</button>\n' +
        '                </div>\n' +
        '            </div>\n' +
        '        </div>';
    node.appendChild(modalFrame);

    const modalTarget = document.getElementById(node.getAttribute("data-modal")),
        modalContent = modalFrame.querySelector("[data-modal-content]"),
        modalTitle = modalFrame.querySelector("[data-modal-title]"),
        closeBtns = node.querySelectorAll("[data-modal-close]"),
        nextBtn = node.querySelector("[data-modal-next]"),
        prevBtn = node.querySelector("[data-modal-prev]");

    let current = node.getAttribute("data-current");

    const modal = new Modal(modalTarget, {
        placement: 'top-center',
        backdrop: 'dynamic',
        backdropClasses: 'bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40',
        closable: true
    });

    gallery.forEach((image,index) => {
        image.addEventListener("click",function(event) {
            current = index;
            if(current === 0) {
                prevBtn.classList.add("invisible");
            }
            else {
                prevBtn.classList.remove("invisible");
            }

            if(current >= (Object.keys(gallery).length-1)) {
                nextBtn.classList.add("invisible");
            }
            else {
                nextBtn.classList.remove("invisible");
            }
            modalTitle.innerHTML = _self.escapeHtml(this.getAttribute("data-title"));
            modalContent.innerHTML = '<img src="' + this.getAttribute("href") + '" class="h-auto max-w-full" alt="' + _self.escapeHtml(modalTitle.innerHTML) + '"/>';
            modalContent.innerHTML = '<figure class="m-0 relative">\n' +
                '  <img class="h-auto max-w-full mx-auto" src="' + this.getAttribute("href") + '" alt="' + _self.escapeHtml(modalTitle.innerHTML) + '">\n' +
                '  <figcaption class="absolute px-4 text-lg text-white bottom-6 w-full"><p class="text-center">' + _self.escapeHtml(this.getAttribute("data-caption")) + '</p></figcaption>\n' +
                '</figure>';
            modal.show();
            event.preventDefault();
        })
    });

    closeBtns.forEach(btn => {
        btn.addEventListener("click",function(event) {
            modal.hide();
            event.preventDefault();
        });
    });

    nextBtn.addEventListener("click",function(event) {
        modal.hide();
        gallery[current+1].click();
        event.preventDefault();
    });

    prevBtn.addEventListener("click",function(event) {
        modal.hide();
        gallery[current-1].click();
        event.preventDefault();
    });

    window.onpopstate = history.onpushstate = function(e)
    {
        modal.hide();
    };

};

Controller.prototype.escapeHtml = function(text) {
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };

    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
}

// ***** Map ****** //

Controller.prototype.loadMapApi = function() {

    const gMap = document.getElementById("gmap");

    if(!gMap) {

        const s = document.createElement("script");
        s.id = "gmap";
        s.type = "text/javascript";
        s.async = "async";
        s.defer = "defer";
        s.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDYzJ3mEz8vd8eeUZ7Wq_etniDk4jp9ICo&callback=gMapCallback";
        document.head.appendChild(s);
    }
    else {
        window.gMapCallback();
    }

};

// ***** Search ****** //

Controller.prototype.toggleSearch = function(node) {

    const input = node.querySelector(".input"),
        search = input.classList.contains("active");

    if(search) {
        return;
    }

    node.addEventListener("click",function(event) {
        input.classList.add("active");
        input.focus();
        event.stopPropagation();
    });

    document.body.addEventListener("click",function() {
        input.classList.remove("active");
    });

};

// ***** Accordion ****** //

/**
 * @param node
 */
Controller.prototype.accordion = function(node) {

    const items = node.querySelectorAll("[data-accordion-item]"), accordionItems = [], _self = this;

    items.forEach((item,index) => {
        accordionItems.push({
            id: item.getAttribute("data-accordion-item"),
            triggerEl: item.querySelector(".toggle"),
            targetEl: item.querySelector(".toggle-content"),
            active: index === 0
        });
    });

    const accordion = new Accordion(node,accordionItems,{
        activeClasses: 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white',
        inactiveClasses: 'text-gray-500 dark:text-gray-400',
        onOpen: (obj,item) => {
            const icn = item.triggerEl.querySelector("[data-accordion-icon]");

            obj._items.forEach(elm => {
                const icon = elm.triggerEl.querySelector("[data-accordion-icon]");
                icon.classList.remove("rotate-0");
                icon.classList.add("-rotate-90");
            });

            icn.classList.add("rotate-0");
            icn.classList.remove("-rotate-90");
        },
        onClose: (obj,item) => {
            const icn = item.triggerEl.querySelector("[data-accordion-icon]");

            icn.classList.remove("rotate-0");
            icn.classList.add("-rotate-90");
        },
        onToggle: (obj,item) => {
            _self.scrollTo(1,item.triggerEl);
        }
    });

};

Controller.prototype.toggle = function(node) {

    const items = node.querySelectorAll("[data-toggle-item]");

    items.forEach(item => {
        const container = item.querySelector(".toggle-content"),
            icn = item.querySelector("[data-toggle-icon]");

        item.querySelector(".toggle").addEventListener("click",function(event){
            if(container.classList.contains("hidden")) {
                this.setAttribute("aria-expanded",true);
                container.classList.remove("hidden");
                icn.classList.remove("-rotate-90");
                icn.classList.add("rotate-0");
            }
            else {
                this.setAttribute("aria-expanded",false);
                container.classList.add("hidden");
                icn.classList.remove("rotate-0");
                icn.classList.add("-rotate-90");
            }
            event.preventDefault();
        });
    });

};

Controller.prototype.scrollObserver = (node) => {
    // console.log("scrollObserver");
    onscroll = (event) => {
        if (window.scrollY > 5) {
            node.classList.add("scroll")
        } else {
            node.classList.remove("scroll")
        }
    };
};

Controller.prototype.teaserScaling = (node) => {
    const images = node.querySelectorAll("li figure");
    const timeout = 120;
    let timer = timeout;
    const callback = function (elements,observer) {
        if(elements[0].isIntersecting) {
            images.forEach((img) => {
                setTimeout(() => img.classList.add("opacity-100"),timer);
                timer = timer+timeout;
            });
            observer.disconnect();
        }
    }

    if(images.length > 0) {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.2,
        };

        const observer = new IntersectionObserver(callback,options);
        observer.observe(node)
    }
};

export default Controller